import React, { createContext } from 'react';
import { Component } from "puzzle";

const ViewContext = createContext({
  viewType: "COMFORTABLE",
  setViewType: (viewType: "COMFORTABLE" | "COMPACT") => {
  }
});


class ViewProvider extends Component {
  state = {
    viewType: "COMFORTABLE",
  };

  /**
   * Set viewType state
   * @param viewType
   */
  setViewType = (viewType: 'COMFORTABLE' | 'COMPACT' = 'COMFORTABLE') => {
    this.setState({
      viewType
    })
  }

  render() {
    const { children } = this.props;
    const { viewType } = this.state;
    const contextValue = {
      viewType,
      setViewType: this.setViewType,
    };
    return (
      <ViewContext.Provider value={contextValue}>
        {children}
      </ViewContext.Provider>
    );
  }
}

export { ViewContext, ViewProvider };
